import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ConfirmationModal, Typography } from 'seagull';
import RecipientDetails from '~/components/RecipientDetails/RecipientDetails';
import { useLocaleKeys } from '~/i18n';
import styles from './ReadyToSendModal.module.scss';
export default function ReadyToSendModal(props) {
    const { t: texts } = useLocaleKeys('components.agreementStudio.readyToSend');
    const { t: commonButtons } = useLocaleKeys('common.buttons');
    const { firstName, lastName, email, companyName, reviewers, dismissModal } = props;
    const effectiveReviewers = reviewers.filter((reviewer)=>reviewer.firstName && reviewer.lastName && reviewer.email);
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'ready_to_send_confirm'
            },
            secondaryButton: {
                name: 'ready_to_send_cancel'
            }
        },
        title: texts.title(),
        testId: "send-proposal-modal",
        width: "700px",
        content: /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    weight: "normal",
                    children: texts.sendDescription()
                }),
                /*#__PURE__*/ _jsx(RecipientDetails, {
                    testId: "primary-recipient",
                    firstName: firstName,
                    lastName: lastName,
                    email: email,
                    companyName: companyName,
                    badge: effectiveReviewers.length > 0 ? 'required' : undefined
                }),
                effectiveReviewers.length > 0 && /*#__PURE__*/ _jsxs("div", {
                    className: styles.additionalRecipients,
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            weight: "normal",
                            children: texts.additionalRecipients()
                        }),
                        effectiveReviewers.map((reviewer, idx)=>{
                            return reviewer.firstName && reviewer.lastName && reviewer.email && /*#__PURE__*/ _jsx(RecipientDetails, {
                                testId: "additional-recipient-".concat(idx),
                                firstName: reviewer.firstName,
                                lastName: reviewer.lastName,
                                email: reviewer.email,
                                badge: reviewer.isSignatory ? 'required' : undefined
                            }, idx);
                        })
                    ]
                })
            ]
        }),
        textAlignCenter: false,
        onPrimaryButtonClick: ()=>dismissModal(true),
        onSecondaryButtonClick: ()=>dismissModal(false),
        primaryButtonLabel: commonButtons.sendNow(),
        secondaryButtonLabel: commonButtons.back()
    });
}
